//import React, { PureComponent } from "react";
import ReactEcharts from "echarts-for-react";
import { usd, numOr0 } from "../../dataFunctions";

export default function Pie({ pieTitle, pieData }) {
  //console.log(pieData);
  //const pieSum=0;
  const initialVal = 0;
  const pieSum = pieData.reduce(
    (accumulator, currentVal) => accumulator + numOr0(currentVal?.value),
    initialVal
  );
  //console.log(pieSum);

  const option = {
    title: {
      text: pieTitle,
      subtext: "Total: $" + usd(pieSum, 0), //,1
      // x: "center",
      left: "center",
      top: "center",
      textStyle: {
        // color: "black",
      },
      subtextStyle: {
        // color: "black",
        // fontWeight: "bold",
      },
    },
    /*tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },*/
    /*legend: {
      orient: "horizontal",
      bottom: "bottom",
      //orient: "vertical",
      //left: "left",
      data: [
        "135F_Polygon_Aave_USDT",
        "135F_Polygon_Beefy_MATIC | Aave",
        "135F_Celo_Ubeswap_mcUSD-mcEUR",
        "135F_Avax_TraderJoeUSDT.e-DAI.e",
        "135F_Polygon_Autofarm_DAI-USDC-USDT LP (aave) | Curve",
      ],
    },*/
    series: [
      {
        name: "Vault",
        type: "pie",
        // radius: "55%",
        radius: ["50%", "70%"],
        // center: ["50%", "55%"], //50%,60%
        animationDuration: 0, //400
        data: pieData,
        itemStyle: {
          /*normal: {
            label: {
              show: true,
              position: "inner",
              formatter: function (params) {
                return params.value + "%\n";
              },
            },
            labelLine: {
              show: false,
            },
          },*/
          normal: {
            label: {
              show: true,
              position: "outer",
              formatter: function (params) {
                //console.log(params)
                return (
                  params.name +
                  ":\n$" +
                  usd(params.value, 1) +
                  " (" +
                  params.percent +
                  "%)"
                );
              },
            },
            labelLine: {
              show: true,
            },
          },
          /*emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },*/
          emphasis: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <ReactEcharts option={option} style={{ height: "400px", width: "700px" }} />
  );
}
